/** The logo's EQ bars, navy fading into cyan — the brand mark of the hub
 *  and the mobile app bar. Pure divs; no asset to load. `animate` makes the
 *  bars dance a few cycles then rest (see .eq-animate in index.css) —
 *  per-bar duration/delay come from the bar's index so they move like a
 *  meter, not a metronome. */
export default function EqMark({ heights = [7, 12, 6, 14, 9], width = 3, gap = 2, animate = false }) {
  return (
    <span className={'flex items-end' + (animate ? ' eq-animate' : '')} style={{ gap }} aria-hidden="true">
      {heights.map((h, i) => (
        <span
          key={i}
          className="block rounded-[1px]"
          style={{
            height: h,
            width,
            background: 'linear-gradient(180deg, var(--color-navy) 0%, var(--color-cyan) 85%)',
            ...(animate && {
              '--eq-dur': `${0.85 + (i % 4) * 0.13}s`,
              '--eq-delay': `${(i % 3) * 0.09}s`,
            }),
          }}
        />
      ))}
    </span>
  )
}
